import { render, staticRenderFns } from "./SalesVolumeRank.vue?vue&type=template&id=7ffc0c4e&scoped=true&"
import script from "./SalesVolumeRank.vue?vue&type=script&lang=js&"
export * from "./SalesVolumeRank.vue?vue&type=script&lang=js&"
import style0 from "./SalesVolumeRank.vue?vue&type=style&index=0&id=7ffc0c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc0c4e",
  null
  
)

export default component.exports